/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Boundary_DescriptionInputs */

const en_error_boundary_description = /** @type {(inputs: Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected application error occurred.`)
};

const es_error_boundary_description = /** @type {(inputs: Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrio un error inesperado en la aplicacion.`)
};

/**
* | output |
* | --- |
* | "An unexpected application error occurred." |
*
* @param {Error_Boundary_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const error_boundary_description = /** @type {((inputs?: Error_Boundary_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Boundary_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_boundary_description(inputs)
	return es_error_boundary_description(inputs)
});